<template>
  <popup-modal ref="popup">
      <h2 class="title">{{ $t('profile.connect.title') }}</h2>
      <div class="close-popup " @click="cancel">
        <div class="dashed-border"/>
        <img src="@/assets/images/icons/Icon_cancel.svg" alt="">
      </div>
    <p>{{ $t('profile.connect.desc') }}</p>
    <div class="btns py-2">
      <span class="button" @click="confirm">{{ $t('profile.login') }}</span>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from './PopupModal.vue';

export default {
  name: 'NeedAccount',

  components: { PopupModal },

  data: () => ({
    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  methods: {
    show() {
      this.$refs.popup.open();
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    confirm() {
      this.$refs.popup.close();
      this.resolvePromise(true);
    },

    cancel() {
      this.$refs.popup.close();
      this.resolvePromise(false);
    },
  },
};
</script>

<style scoped>
.title {
  font: normal normal bold 24px/33px Open Sans;
  letter-spacing: 0px;
  color: #FFA459;
  margin-right: 3rem;
}
</style>
